/**
 * Settings → Open House Sign-in（/app/creditpullsetting）。
 * 打开页面打 STATSIG.COMMON.VIEW，value=settings_open_house_sign_in。
 *
 * 正在用：登记房源点 Create open house；表格 Copy link；点 QR code；
 * 点 Signed in 人数看名单；Archive / Reactivate。
 * 已不算：填地址/城市/日期/价格、autocomplete、创建成功后自动弹出 QR、
 * 关弹窗、翻页。访客签到页和 Get pre-qualified / One Pager 不跨模块。
 * greenbox / gmcc 侧边栏没有这项。
 */
export enum SettingsOpenHouseSignInEvent {
    /** 点 Create open house，落库 */
    INSERT = 'OPEN_HOUSE_SIGN_IN_INSERT',
    /**
     * 复制签到链接。
     * 属性 source=table|qr
     */
    COPY = 'OPEN_HOUSE_SIGN_IN_COPY',
    /** 表格点 QR code 打开二维码 */
    QR = 'OPEN_HOUSE_SIGN_IN_QR',
    /** 点 Signed in 人数，打开签到名单 */
    SIGNUPS_OPEN = 'OPEN_HOUSE_SIGN_IN_SIGNUPS_OPEN',
    /**
     * Archive / Reactivate。
     * 属性 action=archive|reactivate
     */
    ARCHIVE = 'OPEN_HOUSE_SIGN_IN_ARCHIVE',
}
